import { useContext, useEffect, useState } from "react";
import { DEFAULT_LANGUAGE } from "../../shared/constants";
import { useLegal } from "../../shared/hooks/useLegal";
import { ILegalProps } from "./Legal.interface";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";
import { markdownToHtml } from "../../shared/helpers/utils";

function LegalPage(props: ILegalProps) {
    const { lang } = useContext(TranslationContext);
    const { setIsLoading } = useContext(LoadingContext);
    const { isLoading, data } = useLegal(lang ?? DEFAULT_LANGUAGE);
    const [content, setContent] = useState<string>();

    useEffect(() => {
        setIsLoading(isLoading);
        
        if(data?.success) setContent(data.data.legalContent);

    }, [isLoading, data]);

    return (
        <section className="legal_content container-fluid gx-2 pb-6 pt-1">
            <div className="row gx-0">
                <div className="col-12">
                    <div
                        className="text-bd2-md rich_text"
                        dangerouslySetInnerHTML={{ __html: markdownToHtml(content ?? "") }}
                    />
                </div>
            </div>
        </section>
    );
}

export default LegalPage;
